import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.015 8.424a1.363 1.363 0 00-1.342 1.382v9.734a1.361 1.361 0 001.888 1.277 1.363 1.363 0 00.837-1.277V9.806a1.363 1.363 0 00-1.383-1.382zM16.033 24.424a1.366 1.366 0 100-2.732 1.366 1.366 0 000 2.732z" fill="currentColor" /><circle cx="16" cy="16.424" r="15" stroke="currentColor" strokeWidth="2" /></svg>);